import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

const materials = [
  {
    id: 1,
    grade: "중·고등",
    subject: "수학",
    title: "[대치동 수학학원] 수학이 약한 해외 학생들을 위한 수업 안내",
    date: "2020.9.11",
    thumb: "https://blogthumb.pstatic.net/MjAyMDA5MTFfMjg2/MDAxNTk5Nzk2NDMzOTU0.BT9KlhXYWVg0DvnESKtoIbO4_OaL9ncKo5mUMINEsCMg.SCqpfJCbpJCpQaThAm2fgkmS4IwogvahlnfyOU00o3gg.PNG.fmasky/%25BA%25ED%25B7%25CE%25B1%25D7%25C7%25C3%25B7%25A1%25B3%25CA_200911_FMA%25BC%25F6%25C7%25D0_%25C7%25EC%25B4%25F5%25C0%25CC%25B9%25CC%25C1%25F61.png?type=s1",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=222086630207",
    icon: "ri-file-text-line",
    color: "text-[#2563EB]",
  },
  {
    id: 2,
    grade: "중·고등",
    subject: "수학",
    title: "[대치동 수학학원] FMA수학 김희삼 원장이 말하는 \"이것만 알면 수학 100점\"",
    date: "2020.9.9",
    thumb: "https://blogthumb.pstatic.net/MjAyMDA5MDlfODgg/MDAxNTk5NjUxNTUxMDQ1.-L4tm5SKI6LcABbDVEhUeVMpUlT9f7DmXjMHnSB-Ax0g.clxzUjEZ4ofQVveZ-r6Wle0UBU2iVxM7MkmTopyD5gQg.PNG.fmasky/%25B8%25DE%25C0%25CE1.png?type=s1",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=222085007647",
    icon: "ri-file-text-line",
    color: "text-[#2563EB]",
  },
  {
    id: 3,
    grade: "고등",
    subject: "수학",
    title: "[대치동 수학학원] 고등 수포자들을 위한 대치동 전문가의 수학공부법 조언",
    date: "2020.8.29",
    thumb: "https://blogthumb.pstatic.net/MjAyMDA4MjlfMzAw/MDAxNTk4NjAxOTg3NTYz.M7QRKjRPDV8H-XNmie99rmBI9R18GS4RW-IfW6ap0v8g.nB26y8ezXCvtvKs4sqEAdkStMVK4q2I8YYhtog.PNG.fmasky/%25BA%25ED%25B7%25CE%25B1%25D7%25C7%25C3%25B7%25A1%25B3%25CA_200829_FMA%25BC%25F6%25C7%25D0_%25C7%25EC%25B4%25F5%25C0%25CC%25B9%25CC%25C1%25F61.png?type=s1",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=222073704977",
    icon: "ri-file-text-line",
    color: "text-[#2563EB]",
  },
  {
    id: 4,
    grade: "중·고등",
    subject: "수학",
    title: "[대치동 수학학원] FMA수학만의 마라톤 같은 수학 공부법",
    date: "2020.8.27",
    thumb: "https://blogthumb.pstatic.net/MjAyMDA4MjdfMjQy/MDAxNTk4NTA1NDU0NzQ4.Uly8j-VqwyZ_PvDqdM2Z8smoMsFTr1FuaOdH8CHjoy0g.TsZPdZCNJl_9EW5ZIIFqejUQvzf-XMprrz1O0xCso4Eg.PNG.fmasky/%25BA%25ED%25B7%25CE%25B1%25D7%25C7%25C3%25B7%25A1%25B3%25CA-200827-FMA%25BC%25F6%25C7%25D0-%25C7%25EC%25B4%25F5%25C0%25CC%25B9%25CC%25C1%25F61.png?type=s1",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=222072802930",
    icon: "ri-file-text-line",
    color: "text-[#2563EB]",
  },
  {
    id: 5,
    grade: "중·고등",
    subject: "수학",
    title: "대치동 수학학원 FMA 수학 여름방학 특강 개강 안내",
    date: "2017.6.19",
    thumb: "https://blogthumb.pstatic.net/MjAxNzA2MTlfMTIx/MDAxNDk3ODQwMTg0NjYx.NvtsDyLmPZnQmxerGuYREmY0IfMifOa9GMfiHHBuh8kg.5AetVWbbXIcj0IMXTMkxEwHyJsA7Q9tVsFEBM9WOIIkg.PNG.fmasky/%25BF%25A9%25B8%25A7%25B9%25E6%25C7%25D0_%25C6%25AF%25B0%25AD_%25BD%25E6%25B3%25D7%25C0%25CF.jpeg?type=s1",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=221032632058",
    icon: "ri-file-text-line",
    color: "text-emerald-500",
  },
  {
    id: 6,
    grade: "중학교",
    subject: "수학",
    title: "삼각형의 외심과 내심이란? 휘문중학교 학생들을 위한 FMA 수학 자료",
    date: "2017.6.8",
    thumb: "https://blogthumb.pstatic.net/MjAxNzA2MDhfMTQ4/MDAxNDk2ODgxMDMzNDQ4.RDXNcdsZI1MJbn3L5UBblOsnqlNcBvqPxJZvZHcXmRUg.AVXUTZ7jt_rUo4pui2IYacPLEbbZkVRQAoF9kSoA_5wg.PNG.fmasky/1.png?type=s1",
    link: "https://blog.naver.com/PostView.naver?blogId=fmasky&logNo=221024248730",
    icon: "ri-file-text-line",
    color: "text-orange-500",
  },
];

export default function Materials() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#1E3A5F] mb-4">학습자료실</h1>
          <p className="text-slate-500 text-lg">FMA수학학원의 학습자료를 확인하세요</p>
        </div>

        {/* Materials List */}
        <div className="space-y-4">
          {materials.map((material) => (
            <a
              key={material.id}
              href={material.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-5 bg-white rounded-2xl p-5 border border-slate-100 hover:border-[#2563EB]/30 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-16 h-16 rounded-xl overflow-hidden shrink-0 bg-slate-50">
                <img
                  src={material.thumb}
                  alt={material.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-[#2563EB]/10 text-[#2563EB]">
                    {material.grade}
                  </span>
                  <span className="text-xs text-slate-400">{material.subject}</span>
                </div>
                <p className="font-medium text-slate-700 text-sm leading-snug group-hover:text-[#2563EB] transition-colors">{material.title}</p>
                <p className="text-xs text-slate-400 mt-1">{material.date}</p>
              </div>
              <div className="shrink-0 w-9 h-9 flex items-center justify-center bg-[#2563EB]/10 rounded-lg group-hover:bg-[#2563EB] transition-colors">
                <i className="ri-external-link-line text-sm text-[#2563EB] group-hover:text-white transition-colors" />
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://blog.naver.com/fmasky"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center whitespace-nowrap h-11 px-8 bg-[#1E3A5F] hover:bg-[#2563EB] text-white font-medium rounded-lg text-sm transition-colors cursor-pointer gap-2"
          >
            <i className="ri-global-line" />
            네이버 블로그에서 더 보기
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}
